
import { apiDistributionDistributionRelationLog } from "@/api/shop";
import { Component, Prop, Vue } from "vue-property-decorator";
import lsPagination from "@/components/ls-pagination.vue";
import { RequestPaging } from "@/utils/util";
import { row } from "mathjs";
@Component({
    components: {
        lsPagination,
    },
})
export default class ShopList extends Vue {
    /** S Data **/
    $refs!: { addDistributionRef: any; setLeaderRef: any; setMerchantRef: any };
    apiDistributionDistributionRelationLog =
        apiDistributionDistributionRelationLog;
    pager: RequestPaging = new RequestPaging();

    searchObj = {
        name: "",
        change_type: "",
        action: "",
    };

    typeLists: any[] = [];

    /** E Data **/
    /** S Methods **/

    // 获取分销商列表
    getLists(page?: number): void {
        console.log(page);
        page && (this.pager.page = page);
        this.pager
            .request({
                callback: apiDistributionDistributionRelationLog,
                params: {
                    ...this.searchObj,
                },
            })
            .then((res) => {
                this.pager.lists.forEach((v: any) => {
                    this.typeLists.forEach((type: any) => {
                        if (type.key === v.action) {
                            console.log(type.value);
                            this.$set(v, "action_desc", type.value);
                        }
                    });
                });
            });
    }

    // 重置搜索
    reset(): void {
        Object.keys(this.searchObj).map((key) => {
            this.$set(this.searchObj, key, "");
        });
        this.getLists(1);
    }

    /** E Methods **/

    /** S ods **/
    created() {
        this.getLists(1);
    }
}
